import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Checkbox, Radio, Spin, DatePicker } from "antd";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import dayjs from "dayjs";

import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";
import noLanguageJson from "./utils/language/leStudy/noLanguage.json";

export default class ViewConsentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "0",
      i_accept_checkbox: "",
      permission_to_link_clinical_info: "",
      permission_to_contact_third_parties: "",
      participant_in_familial_als_group_meetings: "",
      electronic_signature_acknowledgment: "",
      consent_form_status: false,
      ecas_user_type: "",
      ecas_is_accepted: false,
      consent_form_date: null,
      full_name: "",
      loading: false,
    };
  }
  componentDidMount() {
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    if (RESEARCH_TYPE == "Asymptomatic Study") {
      Bridge.demographics
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Acknowledgment Signature Full Name") {
                  this.setState({ full_name: item.value });
                }
                if (item.field == "Acknowledgment Signature Date") {
                  this.setState({ signature_date: item.value });
                }
                if (item.field == "Familial ALS Group Meetings") {
                  this.setState({
                    participant_in_familial_als_group_meetings: item.value,
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "ECAS Study") {
      Bridge.demographics.ecas_study
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Consent form signed?") {
                  this.setState({
                    ecas_is_accepted: item.value == "Yes" ? true : false,
                  });
                }
                if (item.field == "User Type") {
                  this.setState({ ecas_user_type: item.value });
                }
              }
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "LE Study") {
      this.setState({ loading: true });
      Bridge.demographics.le_study
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Consent form signed?") {
                  this.setState({
                    ecas_is_accepted: item.value == "Yes" ? true : false,
                  });
                }
                if (item.field == "Consent form signed Date") {
                  this.setState({
                    consent_form_date: item.value ? dayjs(item.value) : "",
                  });
                }
                if (item.field == "Consent Form Full Name") {
                  this.setState({
                    full_name: item.value,
                  });
                }
              }
              this.setState({ loading: false });
            }else{
              this.setState({ loading: false });
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      let parameter =
        "?participants_accounts_id=" +
        localStorage.getItem("ap_participants_accounts_id");
      Bridge.consent_form.speech
        .check_consent_form_status(parameter)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            this.setState({ consent_form_status: response.data });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    }
  };

  render() {
    let formData = RESEARCH_TYPE === "LE Study"
      ? this.props.language === "English"
        ? englishJson
        : this.props.language === "Spanish"
          ? spanishJson
          : noLanguageJson
      : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <Spin spinning={this.state.loading}>
            <div className="container">
              <div className="row">
                <div className="col-lg-11 m-auto">
                  <div className="demographic-single-section">
                    <a href="/dashboard" className="back-arrow width-fit-content">
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      {formData.page.backButtonTextDashboard}
                    </a>
                    <div>
                      <div className="header">
                        <h3>{formData.page.consentForm.title}</h3>
                        <div className="white-block"></div>
                      </div>

                      <div className="form-fields">
                        {RESEARCH_TYPE == "modality.ai" && (
                          <div className="form-group pdf-div">
                            <iframe
                              src="./assets/documents/speech-study-consent-form.pdf#toolbar=0"
                              title="Consent Form"
                              width="100%"
                              height="600px"
                            ></iframe>
                          </div>
                        )}
                        {RESEARCH_TYPE == "Asymptomatic Study" && (
                          <div className="form-group pdf-div">
                            <iframe
                              src="./assets/documents/asymptomatic-consent-form.pdf#toolbar=0"
                              title="Consent Form"
                              width="100%"
                              height="600px"
                            ></iframe>
                          </div>
                        )}
                        {RESEARCH_TYPE == "ECAS Study" && (
                          <div className="form-group pdf-div">
                            <iframe
                              src="./assets/documents/ecas-study-consent-form.pdf#toolbar=0"
                              title="Consent Form"
                              width="100%"
                              height="600px"
                            ></iframe>
                          </div>
                        )}
                        {RESEARCH_TYPE == "modality.ai" && (
                          <div className="form-group">
                            <br />
                            <Checkbox
                              value={"Yes"}
                              checked={this.state.consent_form_status}
                              style={{ fontSize: 17 }}
                            >
                              I Accept
                            </Checkbox>
                          </div>
                        )}
                        {RESEARCH_TYPE == "Asymptomatic Study" && (
                          <>
                            <div className="form-group">
                              <br />
                              <Checkbox
                                value={"Yes"}
                                checked={true}
                                style={{ fontSize: 17 }}
                              >
                                I Accept
                              </Checkbox>
                            </div>
                            <div className="form-group">
                              <Checkbox
                                value={"Yes"}
                                checked={true}
                                style={{ fontSize: 17 }}
                              >
                                I give permission to link my clinical information
                                from PREVENT ALS to my digital data. I understand
                                that means select EverythingALS staff will have
                                access to identifiable clinical information.
                              </Checkbox>
                            </div>
                            <div className="form-group">
                              <Checkbox
                                value={"Yes"}
                                checked={true}
                                style={{ fontSize: 17 }}
                              >
                                I give permission for EverythingALS staff to
                                contact third-parties in order to coordinate
                                linking my digital and clinical information to
                                biosamples
                              </Checkbox>
                            </div>
                            <div className="form-group">
                              <label className="input-heading">Check one:</label>
                              <br />
                              <Checkbox
                                value={"Yes"}
                                onChange={(event) =>
                                  this.setState({
                                    participant_in_familial_als_group_meetings:
                                      "I would like to participant in Familial ALS group meetings to provide feedback.",
                                  })
                                }
                                checked={
                                  this.state
                                    .participant_in_familial_als_group_meetings ==
                                  "I would like to participant in Familial ALS group meetings to provide feedback."
                                    ? true
                                    : false
                                }
                                style={{ fontSize: 17 }}
                              >
                                I would like to participant in Familial ALS group
                                meetings to provide feedback.
                              </Checkbox>
                              <Checkbox
                                value={"Yes"}
                                onChange={(event) =>
                                  this.setState({
                                    participant_in_familial_als_group_meetings:
                                      "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions.",
                                  })
                                }
                                checked={
                                  this.state
                                    .participant_in_familial_als_group_meetings ==
                                  "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions."
                                    ? true
                                    : false
                                }
                                style={{ fontSize: 17 }}
                              >
                                I Do not wish to be invited to the Familial ALS
                                group meetings, and prefer to have one on one
                                sessions.
                              </Checkbox>
                            </div>
                            <div className="form-group">
                              <label className="input-heading">
                                Electronic Signature Acknowledgment{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Checkbox
                                value={"Yes"}
                                checked={true}
                                style={{ fontSize: 17 }}
                              >
                                I understand what the study is about, and my
                                questions so far have been answered. I agree to
                                take part of this study.
                              </Checkbox>
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label className="input-heading">
                                    Full Name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="full_name"
                                    placeholder="Full Name"
                                    value={this.state.full_name}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="input-heading">
                                    Date <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Date"
                                    name="signature_date"
                                    value={this.state.signature_date}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {RESEARCH_TYPE == "ECAS Study" && (
                          <>
                            <div className="form-group">
                              <br />
                              <Checkbox
                                value={"Yes"}
                                checked={this.state.ecas_is_accepted}
                                style={{ fontSize: 17 }}
                              >
                                I Accept
                              </Checkbox>
                            </div>
                          </>
                        )}
                        {RESEARCH_TYPE == "LE Study" && (
                          <>
                            <div className="form-group pdf-div">
                              {this.props.language == "English" ? (
                                <iframe
                                  src={"https://eals-studentdashboard-assets.s3.us-west-1.amazonaws.com/R16_English+ICF.docx.pdf#toolbar=0"}
                                  title="Consent Form"
                                  width="100%"
                                  height="600px"
                                />
                              ) : (
                                <iframe
                                  src={"https://eals-studentdashboard-assets.s3.us-west-1.amazonaws.com/R16_ICF+Spanish.pdf#toolbar=0"}
                                  title="Consent Form"
                                  width="100%"
                                  height="600px"
                                />
                              )}
                            </div>
                            <div className="form-group">
                              <br />
                              <Radio.Group
                                value={this.state.ecas_is_accepted}
                                style={{ fontSize: 17 }}
                              >
                                <Radio
                                  value={true}
                                  style={{ fontSize: 17 }}
                                >
                                  {formData.page.consentForm.iAccept}
                                </Radio>
                                <Radio
                                  value={false}
                                  style={{ fontSize: 17 }}
                                >
                                  {formData.page.consentForm.doNotAccept}
                                </Radio>
                              </Radio.Group>
                            </div>
                            <div className="row">
                              <div className="form-group col-lg-5 pl-0">
                                <label
                                  htmlFor="consent-form-full-name mb-2"
                                  style={{ fontSize: 17, marginBottom: 10 }}
                                >
                                  {formData.page.consentForm.fullName} <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  id="consent-form-full-name"
                                  className="form-control"
                                  value={this.state.full_name || ""}
                                  onChange={e => this.setState({ full_name: e.target.value })}
                                  disabled={true}
                                />
                              </div>
                              <div className="form-group col-lg-5 pl-0">
                                <label
                                  htmlFor="consent-form-date mb-2"
                                  style={{ fontSize: 17, marginBottom: 10 }}
                                >
                                  {formData.page.consentForm.consentFormDate} <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                  id="consent-form-date"
                                  className="form-control consent-form-date"
                                  format="MM/DD/YYYY"
                                  style={{ height: "58px", pointerEvents: 'none' }}
                                  value={this.state.consent_form_date}
                                />
                              </div>
                              <div class="col-12">
                                <label class="input-heading" style={{ fontSize: 17, marginTop: 10 }}>
                                  {formData.page.consentForm.consentSignDateAndTime}<br/>
                                  {this.state.consent_form_date ? this.state.consent_form_date.format("MM/DD/YYYY, HH:mm A") : ""}
                                </label>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
        <Footer />
      </div>
    );
  }
}
